import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'mm-iframe-media',
    templateUrl: './iframe-media.component.html',
    styleUrls: ['./iframe-media.component.scss'],
    standalone: false
})
export class IframeMediaComponent {
    @Input({required: true}) mediaLink!: string;

    @Output()
    public mediaLoaded: EventEmitter<void> = new EventEmitter<void>();

    public iframeReady(): void {
        this.mediaLoaded.emit();
    }
}
